import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getTrxMonthToMonth = createAsyncThunk('report/getTrxMonthToMonth', async (__, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/dashboard/reports/total-trx-month-to-month`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
